<template>
  <div>
    <CrudGrid
      :footer-text="$t('messages.items_per_page')"
      :headers="headers"
      :items="option_not_to_donates"
      :loading="loading"
      :page="page"
      :options.sync="options"
    >
      <template v-slot:header>
        <div class="header-table">
          <CrudFilter :has-filters="hasFilters" @search="applyFilter" @clear="clearFilter">
            <v-list-item>
              <v-text-field
                color="#086318"
                :label="$t('inputs.reasons_not_validation.description')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.description"
              />
            </v-list-item>
            <v-list-item>
              <v-select
                :items="kind_of_donors"
                item-value="name"
                item-text="name"
                color="#086318"
                :label="$t('inputs.reasons_not_validation.kind_of_donor')"
                class="rounded-lg"
                hide-details
                outlined
                dense
                v-model="filterForm.kind_of_donor"
              />
            </v-list-item>
          </CrudFilter>
          <v-btn class="rounded-lg ml-2" elevation="1" color="#41916b" @click="openDialog()">
            <span class="textBtn">{{$t('buttons.new')}}</span>
          </v-btn>
        </div>
      </template>

      <template v-slot:[`item.subItens`]="{ item }">
        <span>{{ getSubItemsText(item) }}</span>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <Menu :resource="item" @editItemGrid="openDialog(item)">
          <ChangeStatus
            :resource="item"
            typeData="not-delete"
            @updateGrid="searchGridData()"
            url="option_not_to_donates"
          />
        </Menu>
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-chip :color="item.deleted_at ? '#fa5252' : '#bedfc5'" dark>
          {{ item.deleted_at ? 'Inativo' : 'Ativo' }}
        </v-chip>
      </template>
    </CrudGrid>

    <Modal v-model="dialog">
      <MotivosNaoValidacaoForm
        :openDialog="dialog"
        :resource="resource"
        @closeDialog="dialog = false, searchGridData()"
      />
    </Modal>
  </div>
</template>

<script>
import { getReasonNotValidations } from "@/service/basic-registrations/ReasonNotValidationService";
import MotivosNaoValidacaoForm from "./ReasonNotValidation.vue";
import Menu from "@/components/widgets/MenuActions-comp.vue";
import ChangeStatus from "@/components/widgets/ChangeStatus-comp.vue";
import CrudGrid from "../widgets/Grid.vue";
import CrudFilter from "../widgets/Filter.vue";
import Modal from "../widgets/Modal.vue";
import { mapActions } from "vuex";
import FormFieldsService from '@/service/FormFieldsService';

export default {
  components: {
    MotivosNaoValidacaoForm,
    Menu,
    ChangeStatus,
    CrudGrid,
    CrudFilter,
    Modal,
  },

  data() {
    return {
      dialog: false,
      loading: false,
      filterForm: {},
      option_not_to_donates: [],
      options: {},
      headers: [
        { text: "Motivo de Não Validação", align: "start", value: "description" },
        { text: "Tipo de Motivo", align: "center", value: "kind_of_donor.name" },
        { text: "Possui SubItens?", align: "center", value: "subItens" },
        { text: "Status", align: "start", value: "status" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      page: 0,
      resource: {},
      kind_of_donors: [],
      actions: [
        {
          name: "Editar",
          type: "modal",
          route: "",
          encryptionName: "",
          encryptionPassword: "",
          componentName: "MotivoNaoValidacaoForm",
        },
      ],
    };
  },

  computed: {
    hasFilters() {
      return Object.values(this.filterForm).some(v => v != null && v !== '');
    },
  },

  async created() {
    this.searchGridData();
    this.changeActionsData(this.actions);
    this.kind_of_donors = await FormFieldsService.getKindOfDonor();
  },

  methods: {
    ...mapActions(["changeSnackBarData", "changeActionsData"]),

    getSubItemsText(item) {
      const total = item.reason_assessments.length || 0;
      return total ? `Sim - ${total}` : 'Não';
    },

    openDialog(item) {
      this.resource = item || {};
      this.dialog = true;
    },

    async searchGridData() {
      this.loading = true;
      try {
        const result = await getReasonNotValidations({
          description: this.filterForm.description || '',
          kindOfDonor: this.filterForm.kind_of_donor || '',
        });
        this.option_not_to_donates = result;
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.changeSnackBarData({
          status: true,
          type: 'erro',
          titleMessage: 'Erro ao buscar dados',
          bodyMessage: '',
          cardColor: 'red',
          titleIcon: 'mdi-close-circle',
        });
      }
    },

    applyFilter() {
      this.searchGridData();
    },

    clearFilter() {
      this.filterForm = {};
      this.searchGridData();
    },
  },
};
</script>

<style scoped>
.header-table {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.textBtn {
  font-family: "Poppins";
  color: #ffffff;
}

@media (max-width: 768px) {
  .header-table {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>
